// extracted by mini-css-extract-plugin
export default {"page":"PS","heading":"QS","subheading":"RS","flavorbox":"SS","inner":"TS","image":"US","label":"VS","flavorselect":"WS","arrow":"XS","flavorswrap":"YS","flavorsheader":"ZS","flavorsnav":"aT","flavorsinner":"bT","cancelbtn":"cT","flavorsbottom":"eT","retakebtn":"fT","continueBtn":"gT","drawerinner":"hT","videowrap":"iT","flavorsbottomnav":"jT"};
    if(module.hot) {
      // 1713912567037
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  